import {
  SET_CREDITS,
  SET_CREDIT_IN_USE,
  CreditsThunkAction,
  SetCreditsActionType,
  SetCreditInUseActionType,
} from './creditsActionTypes';
import { ActiveCredit, Credit } from './creditsTypes';
import CreditsApi from '../../API/credits/Credits.api';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import { CreditTypesEnum } from '../../components/shared/BookingCheckout';

export function setCreditsAction(credits: Credit[]): SetCreditsActionType {
  return {
    type: SET_CREDITS,
    payload: credits,
  };
}

export function setCreditInUseAction(
  credits: ActiveCredit[],
  creditsInUseAmount: number,
  cashAmount: number
): SetCreditInUseActionType {
  return {
    type: SET_CREDIT_IN_USE,
    payload: {
      activeCredits: credits,
      creditsAmount: creditsInUseAmount,
      cashAmount,
    },
  };
}

export function FetchUserCreditsThunk(
  creditType: CreditTypesEnum
): CreditsThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsApi.getCreditsBalances(creditType)
      .then((response) => {
        dispatch(
          setCreditsAction(
            response.data.filter(
              (credit) => !credit.endDate || credit.endDate > Date.now()
            )
          )
        );
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}
